export const localStorageKey = 'hippoWallet';
